import React, { useState } from 'react'
import { Page } from 'pages'
import { AssessmentDefs } from 'pages'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { ratingRQ } from 'store/hooks'
import { queryClient as qc } from 'keys'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getMatchingLearningFetch } from 'store/middlewares/rating.crud'

const MatchingLearning = () => {
    const navigate = useNavigate()
    const [assessmentFilters, setAssessmentFilters] = useState({
        category: null
    })


    const { } = ratingRQ.useGetRating()
    const { assessment } = useSelector(state => state.assessment)
    const { rating } = useSelector(state => state.rating)

    const assessmentDefs = useQuery({
        enabled: !!rating,
        queryKey: [qc.matchingLearning, assessment, rating],
        queryFn: async ({ signal }) => {
            const { data } = await getMatchingLearningFetch({ signal, rating, assessmentFilters })
            return data
        }
    })

    const goAssessmentDef = ({ id }) => navigate(`${app.assessmentDefs}/${id}`)

    return (
        <Page>
            <AssessmentDefs
                onSelectAssessment={goAssessmentDef}
                assessments={assessmentDefs}
                assessmentFilters={assessmentFilters}
                setAssessmentFilters={setAssessmentFilters}
            />
        </Page>
    )
}

export default MatchingLearning